var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCollapseCircleCheck = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 20.0416C15.9935 20.0416 20.0416 15.9935 20.0416 11C20.0416 6.00648 15.9935 1.95843 11 1.95843C6.00648 1.95843 1.95843 6.00648 1.95843 11C1.95843 15.9935 6.00648 20.0416 11 20.0416ZM21 11C21 16.5228 16.5228 21 11 21C5.47715 21 0.999998 16.5228 0.999998 11C0.999998 5.47715 5.47715 1 11 1C16.5228 1 21 5.47715 21 11Z",
    fill: "#B41730"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3535 14.6464L14.6464 15.3535L11 11.7071L7.35352 15.3535L6.64641 14.6464L11 10.2929L15.3535 14.6464Z",
    fill: "#B41730"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3535 10.2929L14.6464 11L11 7.35355L7.35352 11L6.64641 10.2929L11 5.93934L15.3535 10.2929Z",
    fill: "#B41730"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCollapseCircleCheck);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/collapse_circle_check.4080de91aa35ad4917c76ecf73a7bf56.svg";